(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4783],{

/***/ 7885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes"]);

  return /*#__PURE__*/react.createElement(ButtonBase/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/react.createElement(MoreHoriz, {
    className: classes.icon
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/react.createElement("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = react.useState(false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [].concat((0,toConsumableArray/* default */.Z)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/react.createElement(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], (0,toConsumableArray/* default */.Z)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = react.Children.toArray(children).filter(function (child) {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map(function (child, index) {
    return /*#__PURE__*/react.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/react.createElement(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other), /*#__PURE__*/react.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = ((0,withStyles/* default */.Z)(Breadcrumbs_styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),

/***/ 59186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var components_lobbypage_components_PageBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57640);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75741);
/* harmony import */ var theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14808);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var StyledDescriptionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Description__StyledDescriptionWrapper",
  componentId: "sc-wg9h44-0"
})(["", "{}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "h1",
  variant: "h2"
}).withConfig({
  displayName: "Description__StyledTitle",
  componentId: "sc-wg9h44-1"
})(["font-size:44px;font-weight:normal;margin-top:10px;margin-bottom:20px;line-height:1;", " color:", ";", "{font-size:70px;}"], theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontCondensed */ .gH, theme_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].blackDark */ .Z.blackDark, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "p",
  variant: "h2"
}).withConfig({
  displayName: "Description__StyledSubtitle",
  componentId: "sc-wg9h44-2"
})(["margin-top:0;margin-bottom:10px;font-size:18px;font-weight:normal;"]);
var StyledDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "div",
  variant: "body1"
}).withConfig({
  displayName: "Description__StyledDescription",
  componentId: "sc-wg9h44-3"
})(["margin-bottom:10px;margin-top:0;font-size:14px;font-weight:400;color:", ";white-space:break-spaces;line-height:1.57;", "{margin-bottom:20px;}p{margin:0;}a{text-decoration:underline;}ul{margin:0.5em 0;padding-inline-start:1.3em;li::marker{color:", ";}}"], theme_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, function (p) {
  return p.theme.breakpoints.up("md");
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.red;
}); //to remove

var Description = function Description(_ref2) {
  var data = _ref2.data,
      parentPageType = _ref2.parentPageType;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledDescriptionWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_lobbypage_components_PageBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      thisPageName: data.title,
      parentPageType: parentPageType
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledTitle, {
      children: data.title
    }), data.subtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSubtitle, {
      children: data.subtitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDescription, {
      dangerouslySetInnerHTML: {
        __html: data === null || data === void 0 ? void 0 : data.description
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Description);

/***/ }),

/***/ 51484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MV": function() { return /* binding */ LOCALE; },
/* harmony export */   "Wj": function() { return /* binding */ CONSTRUCTION; },
/* harmony export */   "k6": function() { return /* binding */ mapsApiKey; }
/* harmony export */ });
var mapsApiKey = "AIzaSyCj0ryj5kLFxMmeAGUP3X4lftkoVfmcCuU";
var LOCALE = {
  EN: "en",
  HE: "he"
};
var CONSTRUCTION = "construction";

/***/ }),

/***/ 57640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7885);
/* harmony import */ var common_utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51484);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32125);
/* harmony import */ var _common_NextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44074);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








 //Styles




var StyledBreadcrumbs = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "PageBreadcrumbs__StyledBreadcrumbs",
  componentId: "sc-t3c85e-0"
})(["", "{padding-top:20px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledActiveLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
  displayName: "PageBreadcrumbs__StyledActiveLink",
  componentId: "sc-t3c85e-1"
})(["font-weight:bold;color:", ";"], function (p) {
  return p.theme.colors.black;
});

var PageBreadcrumbs = function PageBreadcrumbs(_ref) {
  var thisPageName = _ref.thisPageName,
      parentPageType = _ref.parentPageType,
      assetType = _ref.assetType;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__.useTranslations)("breadcrumbs");

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      asPath = _useRouter.asPath;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (window !== undefined) {
      setTimeout(function () {
        var lastLi = document.querySelector("#breadcrumbs li:last-child"); // add aria-current="page" to the last li

        lastLi === null || lastLi === void 0 ? void 0 : lastLi.setAttribute("aria-current", "page");
      });
    }
  }, []);

  var getParentPageUrl = function getParentPageUrl(parentPageType) {
    return parentPageType === "all-assets" ? "/assets-list/all-assets" : parentPageType === "assets-list" ? "/assets-list/offices" : parentPageType === "about" ? "/about/about-us" : parentPageType === "investments" ? "/about/about-us" : "/investor-relations";
  };

  var breadcrumbArray = [{
    position: 1,
    name: t("main"),
    item: "/"
  }, {
    position: 2,
    name: t(parentPageType),
    item: getParentPageUrl(parentPageType)
  }, {
    position: 3,
    name: thisPageName,
    item: asPath
  }];

  if (assetType) {
    var assetItem = {
      position: 3,
      name: t(assetType),
      item: "/assets-list/".concat(assetType)
    };
    breadcrumbArray.splice(2, 0, assetItem);
    breadcrumbArray[3].position = 4;
  }

  if (assetType === common_utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONSTRUCTION */ .Wj) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBreadcrumbs, {
        id: "breadcrumbs",
        separator: "//",
        "aria-label": t("navAria"),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "body2",
            children: t("main")
          })
        }), thisPageName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          href: "/construction",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "body2",
            children: t("construction")
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledActiveLink, {
          variant: "body2",
          children: thisPageName || t("construction")
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
        itemListElements: breadcrumbArray
      })]
    });
  } //Render


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBreadcrumbs, {
      id: "breadcrumbs",
      separator: "//",
      "aria-label": t("navAria"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t("main")
        })
      }), parentPageType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: getParentPageUrl(parentPageType),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t(parentPageType)
        })
      }), assetType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: "/assets-list/".concat(assetType),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t(assetType)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledActiveLink, {
        variant: "body2",
        children: thisPageName
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
      itemListElements: breadcrumbArray
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageBreadcrumbs);

/***/ }),

/***/ 56940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28696);
/* harmony import */ var common_StickyImagePageLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19441);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _common_Description__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59186);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var StyledDescription = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TemplatePage__StyledDescription",
  componentId: "sc-mywshx-0"
})(["font-size:14px;line-height:22px;padding-bottom:100px;color:", ";white-space:break-spaces;overflow-x:auto;h2{strong{font-size:16px;font-weight:normal;}margin-bottom:20px;}p{margin:0;}ul{margin:0.5em 0;padding-inline-start:1.3em;li::marker{color:", ";}}a{text-decoration:underline;}", "{table{word-break:break-word;width:100% !important;}td{padding:0 5px;width:auto !important;min-width:75px;}}"], function (p) {
  return p.theme.colors.black;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.red;
}, function (p) {
  return p.theme.breakpoints.down("sm");
});

var TemplatePage = function TemplatePage(props) {
  var _data$main, _data$main2, _data$main3, _image$media, _image$media2, _image$media3, _poster$media, _data$main4, _data$main4$subtitle, _data$main5, _data$main5$text;

  var data = props.data;
  var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();
  var image = isDesktop ? data === null || data === void 0 ? void 0 : (_data$main = data.main) === null || _data$main === void 0 ? void 0 : _data$main.logoDesktop : data === null || data === void 0 ? void 0 : (_data$main2 = data.main) === null || _data$main2 === void 0 ? void 0 : _data$main2.logoMobile;
  var poster = (_data$main3 = data.main) === null || _data$main3 === void 0 ? void 0 : _data$main3.poster; //Render

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(common_StickyImagePageLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    imageUrl: image === null || image === void 0 ? void 0 : (_image$media = image.media) === null || _image$media === void 0 ? void 0 : _image$media.publicUrl,
    altText: image === null || image === void 0 ? void 0 : (_image$media2 = image.media) === null || _image$media2 === void 0 ? void 0 : _image$media2.altText,
    type: image === null || image === void 0 ? void 0 : (_image$media3 = image.media) === null || _image$media3 === void 0 ? void 0 : _image$media3.type,
    poster: poster === null || poster === void 0 ? void 0 : (_poster$media = poster.media) === null || _poster$media === void 0 ? void 0 : _poster$media.publicUrl,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_common_Description__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        data: {
          title: data === null || data === void 0 ? void 0 : data.navigationTitle,
          subtitle: data === null || data === void 0 ? void 0 : (_data$main4 = data.main) === null || _data$main4 === void 0 ? void 0 : (_data$main4$subtitle = _data$main4.subtitle) === null || _data$main4$subtitle === void 0 ? void 0 : _data$main4$subtitle.value,
          description: null
        },
        parentPageType: "investments"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDescription, {
        dangerouslySetInnerHTML: {
          __html: data === null || data === void 0 ? void 0 : (_data$main5 = data.main) === null || _data$main5 === void 0 ? void 0 : (_data$main5$text = _data$main5.text) === null || _data$main5$text === void 0 ? void 0 : _data$main5$text.value
        }
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TemplatePage);

/***/ }),

/***/ 18397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var _components_template_page_TemplatePage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56940);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var TermsOfUse = function TermsOfUse(_ref) {
  var _data$ogImage, _data$ogImage$media;

  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data === null || data === void 0 ? void 0 : data.metaTitle,
      description: data === null || data === void 0 ? void 0 : data.metaDescription,
      additionalMetaTags: [{
        name: "keywords",
        content: data === null || data === void 0 ? void 0 : data.metaKeywords
      }],
      openGraph: {
        title: (data === null || data === void 0 ? void 0 : data.ogTitle) || (data === null || data === void 0 ? void 0 : data.metaTitle),
        description: (data === null || data === void 0 ? void 0 : data.ogDescription) || (data === null || data === void 0 ? void 0 : data.metaDescription),
        images: [{
          url: (data === null || data === void 0 ? void 0 : (_data$ogImage = data.ogImage) === null || _data$ogImage === void 0 ? void 0 : (_data$ogImage$media = _data$ogImage.media) === null || _data$ogImage$media === void 0 ? void 0 : _data$ogImage$media.publicUrl) || ""
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_template_page_TemplatePage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (TermsOfUse);

/***/ }),

/***/ 58123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-use",
      function () {
        return __webpack_require__(18397);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7611,719,5847,9441,9774,2888,179], function() { return __webpack_exec__(58123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);